import { useState, useEffect } from 'react';
import apiClient from '../api/apiClient'; // centralized apiClient

const usePriceData = (tickers) => {
  const [priceData, setPriceData] = useState({});
  const [lastUpdated, setLastUpdated] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!tickers || tickers.length === 0) return;

    const fetchPrices = async () => {
      setLoading(true);
      setError(null);

      try {
        // Use apiClient instead of hardcoded localhost
        const response = await apiClient.get('/stock-data', {
          params: { symbols: tickers.join(',') },
        });

        setPriceData(response.data);
        setLastUpdated(new Date().toLocaleTimeString());
      } catch (err) {
        console.error('Error fetching price data:', err);
        setError(err.response?.data?.error || err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPrices();

    // Update prices every 60 seconds
    const interval = setInterval(fetchPrices, 60000);

    return () => clearInterval(interval);
  }, [tickers]);

  return { priceData, lastUpdated, loading, error };
};

export default usePriceData;
